export const restoreFocusAndTab = eleRef => {
  if (!eleRef.current) return;
  eleRef.current.focus();
  const focusable = Array.from(document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
  const currentIndex = focusable.indexOf(eleRef.current);
  if (currentIndex >= 0 && currentIndex + 1 < focusable.length) {
    setTimeout(() => {
      focusable[currentIndex + 1].focus();
    }, 0);
  }
};